import { getCurrentCulture } from "owa-localize";

export default function checkLanguage(testLanguage: string, enabledLanguages: string[]): boolean {
    const testLocaleParts = testLanguage.toLowerCase().split("-");
    return enabledLanguages.some(val => isLocaleEnabled(testLocaleParts, val.toLowerCase()));
}

// if a locale is enabled, as assume all sub locales are enabled. e.g - if en is enabled, we assume all en-* locales are enabled
function isLocaleEnabled(testLocaleParts: string[], enabledLocale: string) {
    if (testLocaleParts.length === 1 &&
        testLocaleParts[0] === "no" &&
        enabledLocale === "nb" &&
        getCurrentCulture() === "nb-NO") {
        // Special case for Norwegian Bokmal, where 'no' is used in our client code and 'nb' is used in our server code
        // 'no' is the old code for Norwegian, and 'nb' is the new code for Norwegian Bokmal.
        // Adding check for current culture as nn-NO is also using 'no' as its language code.
        return true;
    }
    
    const enabledLocaleParts = enabledLocale.split("-");
    for (let i = 0; i < testLocaleParts.length && i < enabledLocaleParts.length; i++) {
        if (testLocaleParts[i] !== enabledLocaleParts[i]) {
            return false;
        }
    }
    return true;
}
